import { ChatModel } from '@/Workspaces/ChatBot/ChatResultModel'
import { DateToTimestamp } from '@/Helpers/DateHelper';
import { Dexie, type EntityTable } from 'dexie';
import { useLiveQuery } from 'dexie-react-hooks';

export interface ChatBotTestChatRecord {
    recordId: string,
    chatBotDataId: string,
    histories: ChatModel[],
    title?: string,
    updatedTimestamp?: number,
    createdTimestamp?: number,
}

export const chatBotTestDB = new Dexie('ChatBotTestDB') as Dexie & {
    ChatRecords: EntityTable<ChatBotTestChatRecord, 'recordId'>;
};

chatBotTestDB.version(1).stores({
    ChatRecords: 'recordId, chatBotDataId',
})

export function useChatBotTestChatRecordsCount(chatBotDataId: string) {
    return useLiveQuery(() =>
        chatBotTestDB.ChatRecords.where('chatBotDataId').equals(chatBotDataId).count()
        , [chatBotDataId]);
}
export function useChatBotTestChatRecords(chatBotDataId: string, offset: number = 0, limit = 10) {
    return useLiveQuery(async () => {
        const records = await chatBotTestDB.ChatRecords.where('chatBotDataId').equals(chatBotDataId).sortBy("updatedTimestamp")
        records.reverse();
        return records.slice(offset, offset + limit);
    }, [chatBotDataId, offset, limit]);
}

export async function GetChatBotTestChatRecord(recordId: string) {
    const result = await chatBotTestDB.ChatRecords.get(recordId);
    if (result) return result;
}


export async function DeleteChatBotTestChatRecord(recordId: string) {
    const result = await chatBotTestDB.ChatRecords.get(recordId);
    if (result) {
        await chatBotTestDB.ChatRecords.delete(recordId);
    }
}

export async function DeleteAllChatBotTestChatRecord(chatBotDataId: string) {
    await chatBotTestDB.ChatRecords
        .where('chatBotDataId')
        .equals(chatBotDataId)
        .delete();
}

export async function UpdateChatBotTestChatRecordTitle(recordId: string, title: string) {
    const result = await chatBotTestDB.ChatRecords.get(recordId);
    if (result) {
        result.title = title;
        await chatBotTestDB.ChatRecords.put(result);
    }
}

export async function UpsertChatBotTestChatRecord(
    record: ChatBotTestChatRecord
) {
    if (!record.recordId || !record.chatBotDataId) return
    if (record.histories) record.histories = record.histories.filter(x => !x.responseLoading);
    if (!record.createdTimestamp) record.createdTimestamp = DateToTimestamp(new Date());
    record.updatedTimestamp = DateToTimestamp(new Date());

    let result = await chatBotTestDB.ChatRecords.get(record.recordId);
    if (!result) {
        await chatBotTestDB.ChatRecords.put(record);
    }
    else {
        if (JSON.stringify(result?.histories) !== JSON.stringify(record?.histories)) {
            await chatBotTestDB.ChatRecords.put(record);
        }
    }
}